import React from 'react';

function PlatformField({ label, children, className = '' }) {
  return (
    <div className={`platform-field ${className}`.trim()}>
      {label && <div className="platform-field-label">{label}</div>}
      {children}
    </div>
  );
}

export default PlatformField;
